import { IReactChildrenProps } from '@/interfaces/IReactChildren';

export default function AuthTitle({ children }: IReactChildrenProps) {
	return (
		<h1
			className="text-2xl md:text-4xl text-center mb-2 md:mb-2 font-semibold"
			data-testid="auth-title"
		>
			{children}
		</h1>
	);
}
